export var ETaskCustomFilter;
(function (ETaskCustomFilter) {
    ETaskCustomFilter["Archived"] = "ARCHIVED";
    ETaskCustomFilter["NotArchived"] = "NOT_ARCHIVED";
    ETaskCustomFilter["All"] = "ALL";
})(ETaskCustomFilter || (ETaskCustomFilter = {}));
